import React, { useEffect } from "react";
import { CSSTransition } from "react-transition-group";
import { FaTimes } from "react-icons/fa";
import('./style.css');

const CustomModal = ({ show, onClose, title, children, footerContent }) => {
    const closeOnEscapeKeyDown = e => {
        if ((e.charCode || e.keyCode) === 27) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.addEventListener("keydown", closeOnEscapeKeyDown);
        return function cleanup() {
            document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
        };
    }, []);

    useEffect(() => {
        if (show) {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        } else {
            document.getElementsByTagName('body')[0].style.overflow = 'visible';
        }
    }, [show])

    return (
        <CSSTransition
            in={show}
            unmountOnExit
            timeout={{ enter: 0, exit: 300 }}
        >
            <div className="custom-modal" onClick={onClose}>
                <div className="custom-modal-content" onClick={e => e.stopPropagation()}>
                    <div className="custom-modal-header">
                        <h4 className="custom-modal-title">{title}</h4>
                        <button type="button" className="custom-modal-close" onClick={onClose}>
                            <FaTimes style={{ marginBottom: "-3px" }} />
                        </button>
                    </div>
                    <div className="custom-modal-body">{children}</div>
                    {footerContent && 
                    <div className="custom-modal-footer">
                        {footerContent}
                    </div>}
                </div>
            </div>
        </CSSTransition>

    );
}

export default CustomModal;